import React from 'react'
import { Link } from 'react-router-dom'
import { IoMdArrowDropdown } from 'react-icons/io'
import { useContext } from 'react'
import { AuthContext } from '../../authContext/AuthContext'
import { AiFillSetting } from 'react-icons/ai'
import { BiUserCircle } from 'react-icons/bi'
import images from '../../assets'

const Navbar = () => {
  const { currentUser } = useContext(AuthContext)

  return (
    <>
      <div className="sticky z-40 top-0 bg-white shadow w-full h-[50px] flex items-center justify-between px-3 bg-opacity-80">
        <Link to='/' className="text-lg sm:text-2xl text-white flex title-font font-medium items-center">
          <img src={images.logomachine} className='w-26 h-7 sm:w-40 sm:h-8 md:w-48 md:h-9 sm:mr-2 p-[1px] object-fill' alt="" />
        </Link>

        <div className="group relative flex items-center">
          <button className="inline-flex items-center bg-white border border-gray-50 shadow p-[3px] rounded-full focus:outline-none text-sm sm:text-base">
            <span className='text-slate-700 hidden items-center lg:flex mr-3 font-medium from-neutral-100'>
              <BiUserCircle className='text-3xl bg-gray-500 text-white mr-1 p-[2px] bg-300 rounded-full' />
              {currentUser.email}
            </span>
            <IoMdArrowDropdown className='text-gray-700 text-2xl group-hover:rotate-180 transition-all duration-300' />
          </button>
          <ul className='hidden group-hover:block top-[30px] lg:top-[39px] py-2 right-0 absolute overflow-hidden bg-white rounded-md shadow-lg'>
            <li className='text-slate-700 flex items center px-2 py-2 hover:bg-gray-100 cursor-pointer lg:hidden border-b border-gray-400'><span className='text-gray-600 lg:hidden font-semibold'>{currentUser.email}</span></li>
            <li className='text-slate-700 flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-100'>
              <AiFillSetting className='mr-2' /> Settings
            </li>
            {/* <li className='text-slate-700  flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-400'>
              <IoMdLogOut className='mr-2' /> Log out
            </li> */}
            <li className='text-slate-700  flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer'>
              Machines  
              <span className='font-semibold ml-2'>
                v2.0.0
              </span>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Navbar